import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const SAFETY_FILE_CODE: {
  FILE_INVALID_UNRECOGNIZABLE_TYPE: MvnCodeBE;
  FILE_INVALID_UNSUPPORTED_EXTENSION: MvnCodeBE;
  FILE_INVALID_EXCEED_FILE: MvnCodeBE;
} = {
  FILE_INVALID_UNRECOGNIZABLE_TYPE: {
    status: 400,
    ko: "파일 형식을 확인할 수 없습니다.",
    en: "Unable to determine the file type.",
  },
  FILE_INVALID_UNSUPPORTED_EXTENSION: {
    status: 400,
    ko: "확장자가 {type}인 파일은 업로드할 수 없습니다.",
    en: "File with extension {type} cannot be uploaded.",
  },
  FILE_INVALID_EXCEED_FILE: {
    status: 400,
    ko: "파일은 최대 {mb}MB까지 업로드할 수 있습니다.",
    en: "You can upload a file up to {mb}MB.",
  },
};

MvnCodeInitiate(SAFETY_FILE_CODE);
